import { Component } from "react";

export default class ErrorBoundary extends Component {
  state = {
    hasError: false,
  };

  componentDidCatch() {
    this.setState({
      hasError: true,
    });
  }

  render() {
    const {
      props: { children },
      state: { hasError },
    } = this;

    return !hasError ? (
      children
    ) : (
      <div className="p-3 text-center">
        <h3>Something went wrong! Please refresh or go to another page.</h3>
      </div>
    );
  }
}
